// import { Box, Avatar, Typography } from "@mui/material";

// import StatusCell from "./StatusCell";
// import ActionsCell from "./ActionsCell";

// export const getColumns = (
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   setOpenStatusChangeModal,
//    setOpenAssignOrders,           // Add this parameter
//   setSelectedDriverForAssignOrders, // Add this parameter
//   setOpenClearOrders,            // Add this parameter
//   setSelectedDriverForClearOrders 
// ) => [
//   {
//     field: "full_name",
//     headerName: "Full Name",
//     width: 250,
//     renderCell: (params) => (
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           height: "100%",
//         }}
//       >
//         <Avatar
//           src={params.row.profile_photo}
//           alt={params.row.full_name}
//           sx={{ marginRight: 1, height: "36px", width: "36px" }}
//         />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "14px",
//             fontWeight: 500,
//             color: "#48505E",
//           }}
//         >
//           {params.row.full_name}
//         </Typography>
//       </Box>
//     ),
//   },
//   {
//     field: "user_name",
//     headerName: "User Name",
//     width: 160,
//   },

//    {
//     field: "mobile",
//     headerName: "Phone",
//     width: 240,
//   },
//   // {
//   //   field: "email",
//   //   headerName: "Email",
//   //   width: 240,
//   // },
//   {
//     field: "status",
//     headerName: "Status",
//     width: 180,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => (
//       <StatusCell
//         params={params}
//         setSelectedRow={setSelectedDriver}
//         setOpenStatusChangeModal={setOpenStatusChangeModal}
//       />
//     ),
//   },
//   {
//     field: "action",
//     headerName: "Actions",
//     width: 700,
//     sortable: false,
//     renderCell: (params) => (
//       <ActionsCell
//         params={params}
//         handleEdit={handleEdit}
//         setOpenDeleteDriver={setOpenDeleteDriver}
//         setSelectedDriver={setSelectedDriver}
//         setOpenViewDetails={setOpenViewDetails}
//         setSelectedDriverForView={setSelectedDriverForView}
//           setOpenStatusChangeModal={setOpenStatusChangeModal}
//           setOpenAssignOrders={setOpenAssignOrders}
//           setSelectedDriverForAssignOrders={setSelectedDriverForAssignOrders}
//           setOpenClearOrders={setOpenClearOrders}
//           setSelectedDriverForClearOrders={setSelectedDriverForClearOrders}
//       />
//     ),
//   },
// ];



// **********************************************************************************************

// import { Box, Avatar, Typography } from "@mui/material";

// import StatusCell from "./StatusCell";
// import ActionsCell from "./ActionsCell";

// export const getColumns = (
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   setOpenStatusChangeModal,
//   setOpenAssignOrders,
//   setSelectedDriverForAssignOrders,
//   setOpenClearOrders,
//   setSelectedDriverForClearOrders,
//   onRefreshData,
//   allDrivers // Add this parameter
// ) => [
//   {
//     field: "full_name",
//     headerName: "Full Name",
//     width: 250,
//     renderCell: (params) => (
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           height: "100%",
//         }}
//       >
//         <Avatar
//           src={params.row.profile_photo}
//           alt={params.row.full_name}
//           sx={{ marginRight: 1, height: "36px", width: "36px" }}
//         />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "14px",
//             fontWeight: 500,
//             color: "#48505E",
//           }}
//         >
//           {params.row.full_name}
//         </Typography>
//       </Box>
//     ),
//   },
//   {
//     field: "user_name",
//     headerName: "User Name",
//     width: 160,
//   },

//    {
//     field: "mobile",
//     headerName: "Phone",
//     width: 240,
//   },
//   // {
//   //   field: "email",
//   //   headerName: "Email",
//   //   width: 240,
//   // },
//   {
//     field: "status",
//     headerName: "Status",
//     width: 180,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => (
//       <StatusCell
//         params={params}
//         setSelectedRow={setSelectedDriver}
//         setOpenStatusChangeModal={setOpenStatusChangeModal}
//       />
//     ),
//   },
//   // {
//   //   field: "action",
//   //   headerName: "Actions",
//   //   width: 700,
//   //   sortable: false,
//   //   renderCell: (params) => (
//   //     <ActionsCell
//   //       params={params}
//   //       handleEdit={handleEdit}
//   //       setOpenDeleteDriver={setOpenDeleteDriver}
//   //       setSelectedDriver={setSelectedDriver}
//   //       setOpenViewDetails={setOpenViewDetails}
//   //       setSelectedDriverForView={setSelectedDriverForView}
//   //         setOpenStatusChangeModal={setOpenStatusChangeModal}
//   //         setOpenAssignOrders={setOpenAssignOrders}
//   //         setSelectedDriverForAssignOrders={setSelectedDriverForAssignOrders}
//   //         setOpenClearOrders={setOpenClearOrders}
//   //         setSelectedDriverForClearOrders={setSelectedDriverForClearOrders}
//   //     />
//   //   ),
//   // },

//   {
//     field: "action",
//     headerName: "Actions",
//     width: 700,
//     sortable: false,
//     renderCell: (params) => (
//       <ActionsCell
//         params={params}
//         handleEdit={handleEdit}
//         setOpenDeleteDriver={setOpenDeleteDriver}
//         setSelectedDriver={setSelectedDriver}
//         setOpenViewDetails={setOpenViewDetails}
//         setSelectedDriverForView={setSelectedDriverForView}
//         setOpenStatusChangeModal={setOpenStatusChangeModal}
//         setOpenAssignOrders={setOpenAssignOrders}
//         setSelectedDriverForAssignOrders={setSelectedDriverForAssignOrders}
//         setOpenClearOrders={setOpenClearOrders}
//         setSelectedDriverForClearOrders={setSelectedDriverForClearOrders}
//         onRefreshData={onRefreshData}
//         allDrivers={allDrivers} // Pass this
//       />
//     ),
//   },
// ];

// *******************************************************************************************

import { Box, Avatar, Typography } from "@mui/material";
import StatusCell from "./StatusCell";
import ActionsCell from "./ActionsCell";
import AssignedOrdersCell from "./AssignedOrdersCell";
import InvoiceScanCell from "./InvoiceScanCell";

export const getColumns = (
  handleEdit,
  setOpenDeleteDriver,
  setSelectedDriver,
  setOpenViewDetails,
  setSelectedDriverForView,
  setOpenStatusChangeModal,
  setOpenAssignOrders,
  setSelectedDriverForAssignOrders,
  setOpenClearOrders,
  setSelectedDriverForClearOrders,
  onRefreshData,
  allDrivers,
  setOpenInvoiceScanModal,
  setSelectedDriverForInvoiceScan,
  allowInvoiceScanFeature // Add this parameter
) => {
  // Base columns that are always shown
  const baseColumns = [
    {
      field: "full_name",
      headerName: "Full Name",
      width: 250,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Avatar
            src={params.row.profile_photo}
            alt={params.row.full_name}
            sx={{ marginRight: 1, height: "36px", width: "36px" }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            }}
          >
            {params.row.full_name}
          </Typography>
        </Box>
      ),
    },
    {
      field: "user_name",
      headerName: "User Name",
      width: 160,
    },
    { 
      field: "mobile",
      headerName: "Phone",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <StatusCell
          params={params}
          setSelectedRow={setSelectedDriver}
          setOpenStatusChangeModal={setOpenStatusChangeModal}
        />
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <ActionsCell
          params={params}
          handleEdit={handleEdit}
          setOpenDeleteDriver={setOpenDeleteDriver}
          setSelectedDriver={setSelectedDriver}
          setOpenViewDetails={setOpenViewDetails}
          setSelectedDriverForView={setSelectedDriverForView}
          setOpenStatusChangeModal={setOpenStatusChangeModal}
          setOpenAssignOrders={setOpenAssignOrders}
          setSelectedDriverForAssignOrders={setSelectedDriverForAssignOrders}
          setOpenClearOrders={setOpenClearOrders}
          setSelectedDriverForClearOrders={setSelectedDriverForClearOrders}
          onRefreshData={onRefreshData}
          allDrivers={allDrivers}
        />
      ),
    },
  ];

  // Invoice Scan column - only shown if feature is enabled
  const invoiceScanColumn = {
    field: "is_invoice_scan_enabled",
    headerName: "Allow Invoice Scan(for Mobile)",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <InvoiceScanCell
        params={params}
        setSelectedRow={setSelectedDriverForInvoiceScan}
        setOpenInvoiceScanModal={setOpenInvoiceScanModal}
      />
    ),
  };

  // If invoice scan feature is enabled, insert it before the action column
  if (allowInvoiceScanFeature === 1) {
    // Insert the invoice scan column before the action column
    const actionColumnIndex = baseColumns.findIndex(col => col.field === "action");
    if (actionColumnIndex !== -1) {
      baseColumns.splice(actionColumnIndex, 0, invoiceScanColumn);
    } else {
      baseColumns.push(invoiceScanColumn);
    }
  }

  // Assigned Invoices column - placed after "Allow Invoice Scan" (or before Actions if that column isn't shown)
  const assignedInvoicesColumn = {
    field: "assigned_invoices",
    headerName: "Assigned Invoices",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <AssignedOrdersCell
        data={params.value}
        count={params.row.assigned_invoice_count}
        driverId={params.row.id}
        driverName={params.row.full_name}
        currentInvoicesState={params.row.current_invoices_state}
        currentInvoicesStateColor={params.row.current_invoices_state_color}
        currentInvoiceDrops={params.row.current_invoice_drops}
        currentInvoiceReferences={params.row.current_invoice_references}
        currentInvoiceLines={params.row.current_invoice_lines}
        currentInvoicesDeliveryDate={params.row.current_invoices_delivery_date}
        hasActiveDelivery={params.row.is_current_delivery_track == 1}
        onClearOrders={(driverId, driverName) => {
          const driver = {
            id: driverId,
            full_name: driverName,
          };
          setSelectedDriverForClearOrders(driver);
          setOpenClearOrders(true);
        }}
        onRefreshData={onRefreshData}
        allDrivers={allDrivers}
      />
    ),
  };

  const actionColumnIndex = baseColumns.findIndex(col => col.field === "action");
  if (actionColumnIndex !== -1) {
    baseColumns.splice(actionColumnIndex, 0, assignedInvoicesColumn);
  } else {
    baseColumns.push(assignedInvoicesColumn);
  }

  return baseColumns;
};